import { useAppDispatch } from '../../../../redux/hooks'
import { FC, useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ScreenContext } from 'react-components'
import { SidebarContainer, FilterWrapper } from './styles'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import Filter from '../../../app-components/filter-sort-section/filter'
import {
    fetchInitialFilters,
    getFilterError,
    getFiltersConfiguration,
    getIsSpaMode,
    getRegionNodeId,
    usePopularFilters,
} from '../../../../redux/filters'
import { createSkeletonFiltersConfiguration } from '../utils/skeleton-utils'
import CancellationPolicyModal from '../../../app-components/filter-components/cancellation-policy-modal'
import ErrorCard from '../../../common/error-card'
import SmartSearchPanel from '../../../app-components/filter-components/smart-search-panel'
import { useSmartSearchActive } from '../../../app-components/filter-components/hooks'

import { useRequestUserConfigContext } from '../../../../hooks/request'

interface Props {
    filterStaticData: FilterSectionTransport
    isLoading?: boolean
}

const FilterSidebar: FC<Props> = ({ filterStaticData, isLoading = false }) => {
    const filtersConfiguration = useSelector(getFiltersConfiguration)
    const filtersError = useSelector(getFilterError)
    const regionNodeId = useSelector(getRegionNodeId)
    const dispatch = useAppDispatch()
    const user = useRequestUserConfigContext()
    const spaMode = useSelector(getIsSpaMode)

    const onRetry = useCallback(() => {
        dispatch(fetchInitialFilters(user, regionNodeId, spaMode))
    }, [dispatch, user, regionNodeId, spaMode])

    const popularFilters = usePopularFilters(filterStaticData.popularFilters)
    const { isDesktop } = useContext(ScreenContext)
    const isSmartSearchActive = useSmartSearchActive()
    const showSmartSearch = isDesktop && isSmartSearchActive

    if (filtersError) {
        return (
            <SidebarContainer isLoading={false}>
                <ErrorCard onButtonClick={onRetry} />
            </SidebarContainer>
        )
    }

    const activeFiltersConfiguration =
        isLoading || !filtersConfiguration
            ? createSkeletonFiltersConfiguration({ filterSection: filterStaticData })
            : filtersConfiguration

    return (
        <>
            <SidebarContainer isLoading={isLoading}>
                {!!showSmartSearch && !isLoading && <SmartSearchPanel />}

                {popularFilters.items.length > 0 && !isLoading && (
                    <FilterWrapper key={popularFilters.type}>
                        <Filter filter={popularFilters} filterStaticData={filterStaticData} shouldCommit />
                    </FilterWrapper>
                )}

                {activeFiltersConfiguration.filters.map((filter, index) => (
                    <FilterWrapper key={`${filter.type}-${index}`}>
                        <Filter filter={filter} filterStaticData={filterStaticData} shouldCommit />
                    </FilterWrapper>
                ))}
            </SidebarContainer>

            <CancellationPolicyModal
                title={filterStaticData.specificFilters.cancellationPolicy.title}
                policyPoints={filterStaticData.specificFilters.cancellationPolicy.policyPoints}
            />
        </>
    )
}

export default FilterSidebar
